import {SearchTimeslot} from '../types/SearchTimeslot';

export enum MetaTypesEnum {
  TITLE = 'title',
  NAME = 'name',
  PROPERTY = 'property',
}

export enum UrlTermsSymbolsEnum {
  CAREPROVIDER_UNIT_TYPE = 'c',
  PLACE = 'p',
  SERVICE_TYPE = 't',
  SYMPTOM = 's',
  FREE = 'f',
  PAGE = 'page',
  LATITUDE = 'lat',
  LONGITUDE = 'lng',
  OPEN_NOW = 'on',
  OPEN_WEEKEND = 'ow',
  CUSTOMER_FEATURE_TYPE = 'cf',
  AFTER_REDIRECT = 'ar',
  TIMESLOT = 'ts',
  ATTRIBUTE = 'att',
  FORCE_SEARCH_RESULTS = 'fsr',
  FORCE_CONTENT_PAGE = 'fcp',
  DISTANCE = 'd',
  TAB = 'tab',
}

export const UrlTermsSymbolTimeslotsEnum: Record<SearchTimeslot, string> = {
  [SearchTimeslot.TODAY]: 'today',
  [SearchTimeslot.TOMORROW]: 'tomorrow',
  [SearchTimeslot.THIS_WEEK]: 'this-week',
  [SearchTimeslot.NEXT_WEEK]: 'next-week',
};

export enum UrlTermsSymbolsIgnoredInCanonicalsEnum {
  SORT_ORDER = 'sort',
  LATITUDE = 'lat',
  LONGITUDE = 'lng',
  OPEN_NOW = 'on',
  OPEN_WEEKEND = 'ow',
  BOOKING_TYPE = 'b',
  AFTER_REDIRECT = 'ar',
}

export enum MetaTagFieldsEnum {
  TITLE = 'title',
  OGTITLE = 'og:title',
  KEYWORDS = 'keywords',
  DESCRIPTION = 'description',
  OGDESCRIPTION = 'og:description',
  OGIMAGE = 'og:image',
  OGURL = 'og:url',
}
